import { useMemo, useSyncExternalStore } from "react";
import { useAuth } from "@itaas/core/auth/useAuth";
import {
  buildMenuCatalog,
  catalogToSidebarSections,
  filterMenuCatalog,
} from "@/core/navigation/menu-catalog";
import {
  getEditionHiddenMenuPaths,
  getTenantEditionSnapshot,
  subscribeTenantEdition,
} from "@/core/navigation/edition-menu-mask";
import {
  getHiddenMenuPaths,
  getMenuVisibilitySnapshot,
  subscribeMenuVisibility,
} from "@/core/navigation/menu-visibility";
import { routes } from "@/router/all_routes";

export interface SidebarItem {
  path: string;
  label: string;
  badge?: "soon" | "live";
}

export interface SidebarSection {
  title: string;
  items: SidebarItem[];
}

/** Menu latéral — catalogue IAM + masque édition (WP-H3) + filtre démo. */
export function useHospitolSidebarItems(): SidebarSection[] {
  const auth = useAuth();
  const visibilityKey = useSyncExternalStore(
    subscribeMenuVisibility,
    getMenuVisibilitySnapshot,
    () => "[]",
  );
  const editionKey = useSyncExternalStore(
    subscribeTenantEdition,
    getTenantEditionSnapshot,
    () => "clinic",
  );

  return useMemo(() => {
    const catalog = buildMenuCatalog(auth);
    const hidden = new Set<string>([
      ...getHiddenMenuPaths(),
      ...getEditionHiddenMenuPaths(),
    ]);
    return catalogToSidebarSections(filterMenuCatalog(catalog, hidden));
  }, [auth, visibilityKey, editionKey]);
}

/** @deprecated */
export const usePharmacySidebarItems = useHospitolSidebarItems;

export function isNavActive(itemPath: string, currentPath: string): boolean {
  if (itemPath === routes.tenantDashboard) {
    return currentPath === itemPath;
  }
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
}
